<template lang="pug">
  v-app#app(v-cloak, :light="isLight", :dark="isDark"  :class="[applicationClasses, $i18n.locale]")
    v-app-bar#app-header(app text height=48, color="grey darken-4")
      div.ml-0(@click="toHome")
        img.hidden-xs-only.mx-3(:src="logo" style="height: 46px;")
        img.hidden-sm-and-up.mx-3(:src="icon" style="height: 46px;")
      v-tooltip(v-if="menu.enabled && !hideIconForSupplier" bottom)
        template(v-slot:activator="{ on }")
          v-btn.small-calendar(text icon color="white" @click="toTimeTablePage" v-on="on")
            v-icon fa-calendar
        span {{$t('timetable_menu')}}
      v-tooltip(v-if="menu.enabled && !hideIconForSupplier && isEnableRepack" bottom)
        template(v-slot:activator="{ on }")
          v-btn.small-calendar(text icon color="white" @click="toRepackTimeTablePage" v-on="on")
            v-icon fa-dropbox
        span {{$t('repack_timetable_menu')}}
      v-tooltip(v-if="menu.enabled" bottom)
        template(v-slot:activator="{ on }")
          v-btn(text icon color="white" @click="menu.drawer = true" v-on="on")
            v-icon menu
        span {{$t('menu')}}
      v-tooltip(bottom v-show="isMeLoaded")
        template(v-slot:activator="{ on }")
          v-btn.hidden-xs-only(text icon color="white" @click="toHome" v-on="on")
            v-icon home
        span {{$t('home')}}
      v-tooltip(bottom v-show="isShowIcon()" v-if="!hideIconForSupplier")
        template(v-slot:activator="{ on }")
          v-btn(text icon small color="white" @click="openDialogStock" v-on="on")
            v-icon search
        span {{$t('stock_menu')}}
      <!--stock-sale(v-if="isShowIcon()")-->
      <!--add-contact(v-if="isShowIcon()" :callFromMenu="true")-->
        stock-sale(
          :onContact="false"
          :hideSearchBtn="true"
          :dialogStockSearch="dialogStockSearch"
          @closeDialogSearch="closeDialogStock"
        )
      v-tooltip(bottom v-show="isShowIcon()" v-if="!hideIconForSupplier")
        template(v-slot:activator="{ on }")
          v-btn.hidden-xs-only(text icon color="white" @click="openDialogContact" v-on="on")
            v-icon local_phone
        span {{$t('contact_menu')}}
        add-contact(
          :callFromMenu="true"
          :dialogContact="dialogContact"
          @closeDialogContact="closeDialogContact"
        )
      v-spacer
      v-tooltip(bottom v-show="isMeLoaded")
        template(v-slot:activator="{ on }")
          v-btn(text icon color="white" @click="forceRefresh" v-on="on")
            v-icon refresh
        span {{$t('force_refresh')}}

      template(v-if="isMeLoaded")
        v-menu(
          offset-y
          left
          bottom
          nudge-bottom="5"
          min-width="280"
          content-class="profile-menu"
          :close-on-content-click="false"
        )
          template(v-slot:activator="{ on }")
            v-btn.px-1(text color="transparent" v-on="on")
              v-icon.white--text account_circle
              span.pl-2.rem8.white--text {{me.name}}
              v-icon.white--text arrow_drop_down

          v-list.pa-0(dense)
            v-list-item(v-for="profile, index in profiles", :key="index")
              v-avatar
                v-icon {{profile.icon}}
              v-list-item-title.rem9 {{profile.value}}

            v-divider
            v-list-item(@click="signOut")
              v-avatar
                v-icon exit_to_app
              v-list-item-title {{$t('_account.signout')}}
      template(v-if="isAuthRequired")
        v-menu(
          offset-y
          left
          bottom
          nudge-bottom="5"
          min-width="280"
          content-class="profile-menu"
          :close-on-content-click="false"
          class="mr-3"
        )
          template(v-slot:activator="{ on }")
            v-btn.button-logout(text icon color="transparent" v-on="on")
              v-icon.grey--text power_settings_new

          v-list.pa-0(dense)
            v-list-item(@click="forceSignOut")
              v-avatar
                v-icon exit_to_app
              v-list-item-title {{$t('_account.force_signout')}}

    v-navigation-drawer#app-menus(app temporary v-model="menu.drawer")
      v-toolbar(text height=48, color="grey darken-4")
        img.hidden-xs-only.mx-3(:src="logo" style="height: 40px;")
        img.hidden-sm-and-up.mx-3(:src="icon" style="height: 40px;")

      v-treeview(
        v-model="tree"
        :open="open"
        :items="menus"
        item-key="id"
        item-text="title"
        activatable
        hoverable
        open-on-click
        transition
        active-class="grey lighten-4 primary--text"
        return-object
        @update:open="excludeOpen($event)"
        @update:active="toPage($event)"
        search="keyForRoleFilter"
        :filter="menuFilter"
        ref="app-menu"
      )
        template(v-slot:prepend="{ item, open }")
          v-icon(v-if="item.icon") {{item.icon}}

    v-content.display-content
      v-container#app-contents(fluid grid-list-sm)
        transition(name="page-fade" mode="out-in")
          router-view

    v-footer#app-footer.hidden-xs-only(app padless height="30")
      p.space.primary &nbsp;
      p.slash &nbsp;
      p.copyright.pt-1
        i.fa.fa-fw.fa-copyright
        span {{copyright.year}} {{copyright.company}}

    transition(name="fade" v-if="isLoading")
      div#app-loading
        div.app-loading-wrapper
          div.app-loading-container
            i.fa.fa-fw.fa-spinner.fa-pulse.refresh-animate.primary--text
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommonMenus from '@/common/menus.js'
import PageMenus from '@/app/menus.js'
import _ from 'underscore'
import StockSale from '@/app/pages/Stock/sale'
import AddContact from '@/app/pages/Contact/append'
import uuid from 'uuid/v4'

const propagate = (menus, propagateRole = undefined) => {
  return menus.map((menu) => {
    menu.id = uuid()
    if (!menu.role) {
      menu.role = propagateRole
    }
    if (menu.children) {
      menu.chidren = propagate(menu.children, menu.role)
    }
    return menu
  })
}

export default {
  name: 'app-layout-flowerbiz',
  data () {
    return {
      menu: {
        drawer: false,
        enabled: process.env.APP_MENU_ENABLED
      },
      menus: [],
      open: [],
      tree: [],
      copyright: {
        year: process.env.APP_COPYRIGHT_YEAR,
        company: process.env.APP_COPYRIGHT_COMPANY
      },
      dialogStockSearch: false,
      dialogContact: false
    }
  },
  components: {
    StockSale,
    AddContact
  },
  created () {
    this.loadConfig()
    this.reloadMenus()
  },
  watch: {
    '$i18n.locale': function (v) {
      this.reloadMenus()
    }
  },
  computed: {
    hideIconForSupplier () {
      // If role supplier -> only access and show packing list not show any menu
      let checkIsSupplier = false
      if (!this.me || !this.me.roles) {
        return false
      }
      checkIsSupplier = (this.me.roles.length === 2 &&
       this.me.roles.includes('supplier') && this.me.roles.includes('basic'))
      return checkIsSupplier
    },
    ...mapGetters(`common/${process.env.AUTH_STORATEGY}`, [
      'isAuthenticated',
      'isMeLoaded',
      'me',
      'hasRole'
    ]),
    ...mapGetters('common/loading', ['isLoading']),
    ...mapGetters('common/theme', ['theme', 'isDark', 'isLight']),
    ...mapGetters('app/bookmark', ['bookmarks']),
    ...mapGetters('app/config', ['isEnableRepack']),
    applicationClasses () {
      const meta = this.$route.meta
      // Display page title of user using
      if (this.$route.name && this.$route.name !== 'chart_input' &&
        !this.$route.path.includes('master')) {
        let namePath = this.$route.name
        if (this.$t('page_title')[namePath]) {
          document.title = this.$t('page_title')[namePath]
        } else {
          document.title = this.$t('page_title.default_page')
        }
      } else if (this.$route.name && this.$route.path.includes('master')) {
        document.title = this.$t('page_title.master')
      }

      if (!meta) {
        return ''
      }
      const clazz = meta.applicationClasses
      if (!clazz) {
        return ''
      }
      return clazz.join(' ')
    },
    logo () {
      return process.env.APP_LOGO
    },
    icon () {
      return process.env.APP_ICON
    },
    isAuthRequired () {
      return !!this.$route.meta.requiresAuth
    },
    profiles () {
      return [
        {
          icon: 'explore',
          value: this.me.app
        },
        {
          icon: 'security',
          value: this.me.biz
        },
        {
          icon: 'vpn_key',
          value: this.me.code
        },
        {
          icon: 'mail',
          value: this.me.mail
        },
        {
          icon: 'translate',
          value: this.me.language
        },
        {
          icon: 'location_on',
          value: this.me.locale
        },
        {
          icon: 'language',
          value: this.me.timezone
        }
      ]
    },
    menuFilter () {
      return (item, search, textKey) => this.hasRole(item.role)
    }
  },
  methods: {
    ...mapActions(`common/${process.env.AUTH_STORATEGY}`, [
      'signOut',
      'forceSignOut'
    ]),
    ...mapActions(`app/bookmark`, [
      'loadBookmarks'
    ]),
    ...mapActions(`app/config`, [
      'loadConfig'
    ]),
    toHome () {
      const lang = this.$route.params.lang
      if (lang) {
        this.$router.push(`/${lang}`)
      } else {
        this.$router.push('/')
      }
      this.reloadMenus()
    },
    excludeOpen (items) {
      // NOTE Treeview itself doesn't support the exclude accordion.
      // Ensure empty.
      if (items.length === 0) {
        this.open = []
        return
      }
      // Get the edge node of opens list.
      const edgeItem = items[items.length - 1]
      // Resolve ancestor of edge node.
      const menu = this.$refs['app-menu']
      const parentIds = menu.getParents(edgeItem.id)
      const parents = items.filter(i => parentIds.includes(i.id))
      // Update open list.
      this.open = [...parents, edgeItem]
    },
    toPage (items) {
      if (items.length === 0 || items[0].to === undefined) {
        return
      }
      if (items[0].type !== undefined && items[0].type === 'bookmark') {
        let v = window
        v.open(items[0].to, '_blank')
      } else {
        this.$router.push({ name: items[0].to })
      }
    },
    toTimeTablePage () {
      this.$router.push('/timetable')
      this.reloadMenus()
    },
    toRepackTimeTablePage () {
      this.$router.push('/repack/timetable')
      this.reloadMenus()
    },
    toContactPage () {
      window.location.href = '/contact'
    },
    forceRefresh () {
      location.href = location.href
    },
    async reloadMenus () {
      let bookmarks = this.bookmarks

      if (bookmarks.length === 0) { // reload
        while (true) {
          if (this.isAuthenticated) {
            // Only load bookmarks when roles is user basic
            if (this.isShowIcon()) {
              await this.loadBookmarks()
              bookmarks = this.bookmarks
            }
            break
          }
          // wait a little bit, so authentication data can be save in local storage after login
          await new Promise(resolve => setTimeout(resolve, 16))
        }
      }

      this.menus = _.sortBy(
        CommonMenus.resolve(this).concat(PageMenus.resolve(this)).concat(propagate(bookmarks)),
        'displayOrder'
      )
    },
    isShowIcon () {
      if (!this.me || !this.me.roles) {
        return false
      } else {
        let checkUser = ['basic', 'user', 'manager']
        return checkUser.every(i => this.me.roles.includes(i))
      }
    },
    openDialogStock () {
      this.dialogStockSearch = true
    },
    openDialogContact () {
      this.dialogContact = true
    },
    closeDialogStock () {
      this.dialogStockSearch = false
    },
    closeDialogContact () {
      this.dialogContact = false
    }
  }
}
</script>

<style lang="stylus">
@import '../../common/stylus/_theme';

.page-fade-enter-active, .page-fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.1s;
}

.page-fade-enter-active {
  transition-delay: 0.2s;
}

.page-fade-enter, .page-fade-leave-to {
  opacity: 0;
}

#app-contents {
  padding: 4px;
}

.v-btn {
  margin: 6px 4px 4px 4px;
}

.container.grid-list-sm .layout:not(:only-child) {
  margin: -1px -2px
}

#app-footer {
  &:after {
    content: '';
    position: fixed;
    bottom: 25px;
    width: 100%;
    height: 5px;
  }

  min-height: 25px;

  .space {
    flex-basis: auto;
    height: 100%;
    flex-grow: 1;
  }

  .slash {
    flex-basis: 17px;
    border-top-left-radius: 17px;
    height: 170%;
    margin: -10px;
    transform: rotate(40deg);
    margin-left: -11px;
    margin-bottom: 0px;
  }

  .copyright {
    flex-basis: 320px;
    height: 100%;
    text-align: right;
    margin-right: 0.5rem;
    font-size: 0.9rem;
    margin-top: 0.2rem;
  }
}

.v-application.theme--light {
  #app-footer {
    background-color: rgba($material-light.text-color, $material-light.secondary-text-percent);
    color: rgba($material-dark.text-color, $material-dark.secondary-text-percent);

    .divider {
      background-color: $body-bg-light;
    }

    .slash {
      background-color: $body-bg-light;
    }

    &:after {
      background-color: $body-bg-light;
    }
  }
}

.v-application.theme--dark {
  #app-footer {
    background-color: rgba($material-dark.text-color, $material-dark.secondary-text-percent);
    color: rgba($material-light.text-color, $material-light.secondary-text-percent);

    .divider {
      background-color: $body-bg-dark;
    }

    .slash {
      background-color: $body-bg-dark;
    }

    &:after {
      background-color: $body-bg-dark;
    }
  }
}

#app-loading {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.1s ease;

  .app-loading-wrapper {
    height: 100%;
    padding: 0px;
    margin: 0px;
    display: flex;
    align-items: center;

    .app-loading-container {
      width: 180px;
      padding: 10px;
      margin: auto;
      background-color: transparent;
      box-shadow: none;
      border: none;
      transition: all 0.1s ease;

      .refresh-animate {
        font-size: 10rem;
      }
    }
  }
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.v-application.theme--light {
  #app-loading {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.v-application.theme--dark {
  #app-loading {
    background-color: rgba(255, 255, 255, 0.2);
  }
}

.small-calendar {
  .v-icon {
    font-size: 18px!important;
  }
}

.button-logout {
  margin-right: unset!important
}

</style>



// WEBPACK FOOTER //
// src/app/layouts/flowerbiz.vue